import { render } from "./SimpleHeading.vue?vue&type=template&id=c499b4be"
import script from "./SimpleHeading.vue?vue&type=script&lang=js"
export * from "./SimpleHeading.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__